import { combineReducers } from 'redux';
import {
  SET_VIEW,
  ASSIGN_PETITIONS_REQUEST,
  ASSIGN_PETITIONS_SUCCESS,
  ASSIGN_PETITIONS_FAILED,
} from './actionTypes';
import petitionsTableReducer from './PetitionsTable/reducer';
import reAssignTableReducer from './ReassignTable/reducer';
import labelsManage from './LabelsManage/reducer';
import generateCSVReducer from './GenerateCSVModal/reducer';

const initialState = {
  view: null,
  loading: false,
  error: null,
};

const assignReducer = (state = initialState, {
  type, view, error,
}) => {
  switch (type) {
    case SET_VIEW:
      return {
        ...state,
        view,
        loading: false,
      };
    case ASSIGN_PETITIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ASSIGN_PETITIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ASSIGN_PETITIONS_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

const assignRootReducer = combineReducers({
  main: assignReducer,
  petitions: petitionsTableReducer,
  reAssign: reAssignTableReducer,
  labels: labelsManage,
  generateCSV: generateCSVReducer,
});

export default assignRootReducer;
